import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Rx";
import { WebsocketService } from "./websocket.service";
import { environment } from "src/environments/environment";

export interface Message {
    name: string;
    content: string;
}

@Injectable()
export class RealTimeService {
    public messages: Subject<Message>;

    constructor(private wsService: WebsocketService) {


    }

    connect() {
        // Add auth to chat URL
        console.log('connect to ws', environment.wsapiurl + '?auth=' + localStorage.getItem('uid'));
        this.messages = <Subject<Message>>this.wsService.connect(environment.wsapiurl + '?auth=' + localStorage.getItem('uid')).map(
            (response: MessageEvent): Message => {
                return JSON.parse(response.data);
            }
        );
    }

    disconnect() {
        this.wsService.disconnect();
    }

    send(message: any): void {
        this.wsService.sendMessage(message);
    }
}